import { createSlice } from '@reduxjs/toolkit';
import config, { getCurrentLanguage } from './config';

const languageSwitcherInitialState = {
  isActivated: false,
  language: getCurrentLanguage(config.defaultLanguage || 'english'),
};

export const languageSwitcherSlice = createSlice({
  name: 'languageSwitcher',
  initialState: languageSwitcherInitialState,
  reducers: {
    switchActivation: (state) => {
      state.isActivated = !state.isActivated;
    },
    changeLanguage: (state, action) => {
      state.language = getCurrentLanguage(action.payload.language);
    },
  },
});

export const { switchActivation, changeLanguage } =
  languageSwitcherSlice.actions;

export default languageSwitcherSlice.reducer;
